import { type FC, type MouseEvent, useCallback, useEffect, useState } from 'react'
import { Typography } from '@healingpaper/cell'

import { generateTagId } from '@/utils/test-automation'

import type { ExtendTabItem } from '@/features/hospital/components/hospital-detail-template/types'

export interface TabItem {
  text: string
  onClick?: (e: MouseEvent) => void
}

export interface Props {
  items: ExtendTabItem[]
  index?: number
}
const Tab: FC<Props> = ({ index = 0, items }) => {
  const [selectedIndex, setSelectedIndex] = useState(index)
  const onClickTab = useCallback((e: MouseEvent<HTMLElement>, item: TabItem, itemIndex: number) => {
    e.preventDefault()
    setSelectedIndex(itemIndex)
    item?.onClick?.(e)
  }, [])

  useEffect(() => {
    setSelectedIndex(index)
  }, [index])

  const isNotActive = selectedIndex === -1

  return (
    <div className="flex items-center gap-1 px-[10px] bg-white">
      {items
        .filter((item) => item.isVisible)
        .map((item, itemIndex) => {
          const isActive = selectedIndex === itemIndex || (isNotActive && itemIndex === 0)
          return (
            <button
              id={generateTagId('all', 'tab', 'btn', item.id)}
              className={`flex-1 py-3 border-b-[2px] ${isActive ? 'border-b-gray-900' : 'border-b-white'}`}
              role="tab"
              key={item.id + item.text}
              onClick={(e) => {
                e.preventDefault()
                onClickTab(e, item, itemIndex)
              }}
              aria-selected={selectedIndex === itemIndex}
            >
              <Typography
                type={isActive ? 'title3' : 'description1'}
                elementType="h2"
                color={isActive ? 'gray900' : 'gray700'}
              >
                {item.text}
              </Typography>
            </button>
          )
        })}
    </div>
  )
}

export default Tab
